import { motion } from 'framer-motion';
import { SVG_Logo } from 'libs/images/SVG_Logo';
import { conditionalScaleAnimation } from 'libs/styles/animations';
import { EColors, EFonts } from 'libs/styles/styling';
import { Link } from 'react-router-dom';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
}

export const HeaderLeft = (props: Props): JSX.Element => {
    const urlParams = new URLSearchParams(window.location.search);
    const nologo = urlParams.get('nologo');

    return (
        <S_HeaderLeft className={props.className}>
            {!nologo && (
                <Link to="/admin">
                    <motion.div {...conditionalScaleAnimation(true, 1.1, 0.9)}>
                        <S_Logo />
                    </motion.div>
                </Link>
            )}
            <S_Beta>BETA</S_Beta>
        </S_HeaderLeft>
    );
};

const S_HeaderLeft = styled.div`
    display: flex;
    align-items: center;
`;

const S_Logo = styled(SVG_Logo)`
    margin: 4px 20px 0 0;
    cursor: pointer;
    svg {
        width: auto;
        height: 25px;
    }
`;

const S_Beta = styled.span`
    font-size: 13px;
    font-family: ${EFonts.Medium};
    color: ${EColors.ACC2_A};
    margin: 1px 0 0 0;
`;
